import { observer } from "mobx-react-lite";
import { Popup, PopupProps } from "react-map-gl";
import styles from "./MapPopup.module.css";

function MapPopup({ children, ...props }: PopupProps) {
    return (
        <Popup {...props}>
            <div className={styles.container}>
                {children}
            </div>
        </Popup>
    );
}

export default observer(MapPopup);